export default {
  name: 'ScrollableList',
  props: {
    baseUrl: String,
    pageArr: Array,
    bordered: Boolean,
    selectDefaultPage: Boolean
  },
  data: () => ({
    activeClassName: 'active--square',
    endPage: null,
    nextBtnDisable: false,
    prevBtnDisable: false,
    speed: 25,
    nextPage: '',
    prevPage: ''
  }),

  methods: {
    prevPageClick() {
      if (this.prevPage) {
        this.$router.push({ path: `${this.baseUrl}/${this.prevPage.param}` })
      }
    },
    nextPageClick() {
      if (this.nextPage) {
        this.$router.push({ path: `${this.baseUrl}/${this.nextPage.param}` })
      }
    },
    handleButtonDisable(currentPage) {
      if (currentPage === this.endPage) {
        this.nextBtnDisable = true
      }
      if (currentPage === 1) {
        this.prevBtnDisable = true
      }
    },
    updatePage() {
      if (this.endPage != this.pageArr.length) {
        this.endPage = this.pageArr.length
      }

      this.container = document.getElementById('pagination-container')
      this.activeRound = document.getElementsByClassName('active--square')[0]
      if (this.activeRound) {
        const offsetLeft = this.activeRound
          ? this.activeRound.parentElement.offsetLeft - 150
          : 30
        this.container.scrollLeft = offsetLeft

        const currentActiveIndex = this.pageArr.findIndex(
          item => item.param.toString() === this.activeRound.dataset.param
        )

        this.handleButtonDisable(currentActiveIndex + 1)

        this.nextPage = this.pageArr[currentActiveIndex + 1]
        this.prevPage = this.pageArr[currentActiveIndex - 1]
      }
    }
  },
  updated() {
    this.updatePage()
  },
  activated() {
    this.updatePage()
  }
}
